import { Component, OnInit } from '@angular/core';
import { Employee } from 'app/vouchers/Models/employee';
import { OrderDetails } from 'app/vouchers/Models/order-details';
import { Tickets } from 'app/vouchers/Shared/model/tickets';
import { EVoucherType } from 'app/vouchers/Shared/enum/voucher-type.enum';
import { AvailableTickets } from 'app/vouchers/Shared/model/available-tickets';
import { EProvider } from 'app/vouchers/Shared/enum/provider.enum';
import { ProviderNotes } from 'app/vouchers/Shared/provider-notes.const';
import { EPassengerType } from 'app/vouchers/Shared/enum/passenger-type.enum';
import { ResultOfOperation } from 'app/shared/model/result-of-operation.model';
import { Order } from 'app/vouchers/Shared/model/order';

import { VoucherArkia } from 'app/vouchers/Models/VoucherArkia';
import { Router } from '@angular/router';
import { UserMessagesService } from 'app/shared/user-messages/user-messages.service';
import { OrderService } from '../vouchers/order.service';


interface IKeyValue
{
  id: number;
  value: number;
}

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.css']
})


export class OrderDetailsComponent implements OnInit {

  employee:Employee = new Employee();
  employeeTicketQuantity:number;
  nonEmployeeTicketQuantity:number;
  kidTicketQuantity:number;
  maxAvailableTotalTickets:number = 5;
  selectedProviderNotes:string[] = [];//= ['למימוש כרטיס טיסה ביולי-אוגוסט יש לרכוש כרטיס מסוג סוף שבוע']
  orderDetails: OrderDetails = new OrderDetails();
  ticketsPriceList: Tickets[] = [];
  selectedVoucherType:EVoucherType;
  voucherTypes = EVoucherType;
  order = new Order();
  isSubmit : boolean = false;

  employeePrice: IKeyValue 
  nonEmployeePrice : IKeyValue
  childPrice : IKeyValue

  finalPrice: number = 0;

  totalAvailableTicketsForSelectedProivderAndType : AvailableTickets
  
  constructor(private _orderService:OrderService,
              private _router : Router,
              private _userMessages : UserMessagesService) { }

  ngOnInit(): void {
  debugger;

    this._userMessages.clearAll();
    
    this.selectedVoucherType = EVoucherType.weekend;
    this.selectedProviderNotes = ( this.employee.selectedProvider == EProvider.arkia) ? ProviderNotes.arkiaNotes : ProviderNotes.israirNotes;
    this.employee = JSON.parse(sessionStorage.getItem('employee')) as Employee;

    this.employee.selectedProvider = EProvider.arkia;
    
    this._orderService.GetUserUsedBenefitsAmount().subscribe(result => {
      if(result)
      {        
        this.employee.usedBenefits = Number(result.data);
        this.orderDetails.availableBenefits = (this.orderDetails.totalBenefitsForEmployee - this.employee.usedBenefits);
        
      }
      else
      {
        this._userMessages.setErrorMessage("בעיה בזכאויות לטיקטקים - אנא פנה לארגון להמשך בירור")
      }
    })


    // this._orderService.getTicketPrices(this.employee.selectedProvider).subscribe((result: ResultOfOperation<Tickets[]>) =>{
    //   if(result)
    //   {
    //     Object.assign(this.ticketsPriceList, result.data);
    //     this.filterVoucherPrices(); 
    //   }
    //   else
    //   {
        
    //     this._userMessages.setErrorMessage("בעיה בהצגת מחירים, אנא פנה לארגון להמשך בירור");
    //   }
    //   });

    //  this.getTotalTicketsAvailable();
    
  }

  removeTicket(element)
  {
   
    this.orderDetails[element.id]--;
    this.finalPrice = this.getFinalPrice();
     
    if(this.orderDetails.employeeTickets > 0 || this.orderDetails.nonEmployeeTickets > 0 || this.orderDetails.kidsTickets > 0)
    {
      this.isSubmit = true;
    }
    else
    {
      this.isSubmit = false;
    }
  }

  addTicket(element)
  {
    
    let currentTickets = this.orderDetails[element.id];
    if(this.orderDetails[`${element.id}Max`] ===  currentTickets)
    {
      return;
    }
    
    this.orderDetails[element.id]++;
    this.finalPrice = this.getFinalPrice();

    if(this.orderDetails.employeeTickets > 0 || this.orderDetails.nonEmployeeTickets > 0 || this.orderDetails.kidsTickets > 0)
    {
      this.isSubmit = true;
    }
    else
    {
      this.isSubmit = false;
    }
   

  }

  filterVoucherPrices() : void
  {
      this.employeePrice = this.getPrice(EPassengerType.employee); 
      this.nonEmployeePrice = this.getPrice(EPassengerType.nonEmployee);
      this.childPrice = this.getPrice(EPassengerType.child);
  }

  private getPrice(passengerType: EPassengerType) : IKeyValue
  {
    let {id,price} = this.ticketsPriceList.filter(price => price.passengerType == passengerType && price.voucherType == this.selectedVoucherType)[0];
    let result : IKeyValue = {id:id, value:price}
    return result;
  }
  private getFinalPrice() : number
  {
    let result = (this.employeePrice.value * this.orderDetails.employeeTickets) 
                 + (this.nonEmployeePrice.value * this.orderDetails.nonEmployeeTickets)
                 + (this.childPrice.value * this.orderDetails.kidsTickets);
    return result
  }

  createNewOrderAndReceiveVouchers()
  {
      

    this.order.numberOfPayments = this.orderDetails.numberOfPayments;

    let numberOfTickets = this.getTotalNumberOfTicketsPurchased;
    this.order.numberOfEmployeeTicketsOrdered = this.orderDetails.employeeTickets;
    this.order.numberOfNonEmployeeTicketsOrdered = this.orderDetails.nonEmployeeTickets;
    this.order.numberOfPayments = this.orderDetails.numberOfPayments;
    this.order.numberOfChildTicketsOrdered = this.orderDetails.kidsTickets;
    this.order.voucherType = Number(this.selectedVoucherType);
    this.order.providerId = this.employee.selectedProvider;
    
    
    //TODO: 
    //if providerId  = 1 -->  if providerId = 2 -->
      this._orderService.CreateNewOrderArkiaAndGetVouchers(this.order).subscribe((result : ResultOfOperation<VoucherArkia[]>) => {
      if(result)
      {
        //TODO: handle errors 100,200,300 and navigate only when result.IsSuccess = true
        this._router.navigate(['/vouchers/order-summary'],{state:result});
      }
      else
      {
          this._userMessages.setErrorMessage("בעיה ביצירת הזמנה - אנא פנה לארגון העובדים להמשך בירור")
      }
    });

  }
  private getTotalNumberOfTicketsPurchased() : number
  {
    let result :number = this.orderDetails.employeeTickets 
                 + this.orderDetails.nonEmployeeTickets
                 + this.orderDetails.kidsTickets;
    return result
  }

  private getTotalTicketsAvailable() : AvailableTickets
  {
    //2.get from server the available tickets

    let response : AvailableTickets;
    this._orderService.getTotalTicketsAvailable(this.employee.selectedProvider,this.selectedVoucherType).subscribe((result : ResultOfOperation<AvailableTickets>) =>
    {
      if(result)
      {
        this.orderDetails.nonEmployeeTicketsMax = result.data.nonEmployeeTicketsCount;
        this.orderDetails.kidsTicketsMax = result.data.childTicketsCount;
        
      }
      else
      {
       this._userMessages.setErrorMessage("אין כרטיסים זמינים - אנא פנה לארגון להמשך בירור");
      }

    })

    return response;

  }
  
}
